const codes = {
    8: "backspace",
    13: "enter",
    38: "arrowUp",
    40: "arrowDown"
};

const getCode = e => e.keyCode;

const Keyboard = {
    codes: codes,
    getCode: getCode,
    isEnter: e => {
        return codes[getCode(e)] === "enter";
    },
    isBackspace: e => {
        return codes[getCode(e)] === "backspace";
    },
    isUp: e => {
        let code = codes[getCode(e)];
        return code === "arrowUp";
    },
    isDown: e => {
        let code = codes[getCode(e)];
        return code === "arrowDown";
    },
};

export default Keyboard;